import * as Constants from './constants'

export const RESIDENT = "resident"
export const SECONDARY_USER = "secondary_user"
export const GUARD = "guard"
export const PROPERTY_MANAGER = "property_manager"
export const HOA_ADMIN = "hoa_admin"
export const ADMIN = "admin"
export const CT_ADMIN = "ct_admin"
export const roleAccessOrder = [
    RESIDENT,
    SECONDARY_USER,
    GUARD,
    PROPERTY_MANAGER,
    HOA_ADMIN,
    ADMIN,
    CT_ADMIN
]

export const featureEnabledForRole = (feature, role) => {
    switch (feature) {
        case Constants.SCAN_KEY_MODAL: {
            return roleIsAtLeast(GUARD, role)
        }
        case Constants.CREATE_ENTRY_LOG_MODAL: {
            return roleIsAtLeast(GUARD, role)
        }
        case Constants.PARKING_PASS: {
            return roleIsAtLeast(GUARD, role)
        }
        default: {
            return false
        }
    }
}

function roleIsAtLeast(requiredRole, inputRole) {
    const roleMap = {
        "resident": 1,
        "secondary_user": 2,
        "guard": 3,
        "property_manager": 4,
        "hoa_admin": 5,
        "admin": 6,
        "ct_admin": 7
    }
    let requiredLevel = roleMap[requiredRole]
    let userLevel = roleMap[inputRole]

    if (requiredLevel === undefined) {
        throw new Error(`Unknown required role: ${requiredRole}`);
    }

    if (userLevel === undefined) {
        throw new Error(`Unknown user role: ${inputRole}`);
    }

    console.log(`Role evaluation input: ${userLevel} required: ${requiredLevel}`)

    return (userLevel >= requiredLevel)
}